import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PortalCheckBox from '../../portal/controls/checkbox';
import { Button } from '@checkmarx/cx-ui';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../services/ui/toastrService';
import PortalDropdown from '../../portal/portalDropdown';

@inject('translationsStore', 'loginSettingsStore') @observer
export default class LoginSettings extends Component {

    loginStore = this.props.loginSettingsStore;
    t = this.props.translationsStore;

    componentDidMount() {
        this.loginStore.getLoginSettings();
    }

    toggleLoginCredentials = e => {
        this.loginStore.toggleLoginCredentials()
    };

    onChangeDefaultLoginMethod = (e, index, value) => { 
        this.loginStore.changeDefaultLoginMethod(value);
    }

    handleSubmitForm = (e) => {
        e.preventDefault();

        this.loginStore.setLoginSettings().then(() => {
            var level = ToastrLevelsEnum.SUCCESS;
            var message = this.props.translationsStore.translate('LOGIN_SETTINGS_SUCCESS_MESSAGE');
            ToastrService.triggerToastr({ level, message });
        });
    }

    fieldWidth = '48%';


    render() {
        const mac = this.props.translationsStore.translate('MASTER_ACCESS_CONTROL'); 
        const sso = this.props.translationsStore.translate('SINGLE_SIGNON'); 
        const credentials = this.props.translationsStore.translate('CREDENTIALS');

        let list = [];

        if(this.loginStore.availableAuthMethods != null){
            var newlist = JSON.parse(this.loginStore.availableAuthMethods);

            newlist.forEach(element => {
                list.push({id : element.Id, name : element.Name});
            });
        }

        return (
            <form onSubmit={this.handleSubmitForm}>
                <div>
                    <div className="setting-sub-title">
                        {this.t.translate('LOGIN_SETTINGS_SUBTITLE')}
                    </div>
                        <div className='default-login combobox'>
                            <PortalDropdown
                                dataCy='default-login'
                                hintText={this.t.translate('DEFAULT_LOGIN_METHOD')}
                                floatingLabelText={this.t.translate('DEFAULT_LOGIN_METHOD')}
                                width='47%'
                                onChange={this.onChangeDefaultLoginMethod}
                                value={this.loginStore?.defaultLoginMethod}
                                helpTooltipText={this.t.translate('DEFAULT_LOGIN_HELP_TOOLTIP')}
                                items={list.slice()}
                            />
                        </div> 
                        <div className='form-row start' style={{ paddingTop:'40px' }}>
                            <PortalCheckBox
                                dataCy={'tgl-enforce-login-credentials'}
                                dataKey={'enforceLoginCredentials'}
                                checked={this.loginStore.credentialsButton}
                                onCheck={this.toggleLoginCredentials}
                                disabled={this.loginStore.stepInProgress}
                                label={this.t.translate('SHOW_LOGIN_CREDENTIALS')}
                            />
                    </div>         
                        <div className='general-settings-submit'>
                            <Button
                                dataCy='btn-lockout-options-submit'
                                type='submit'
                                inProgress={this.loginStore.stepInProgress}
                                text={this.props.translationsStore.translate('SAVE')} >
                            </Button>
                        </div>
                </div>
            </form>
        );
    }
}